import { render, staticRenderFns } from "./TradingPlan.vue?vue&type=template&id=19fbb600&scoped=true"
import script from "./TradingPlan.vue?vue&type=script&lang=js"
export * from "./TradingPlan.vue?vue&type=script&lang=js"
import style0 from "./TradingPlan.vue?vue&type=style&index=0&id=19fbb600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fbb600",
  null
  
)

export default component.exports